import { configureStore } from '@reduxjs/toolkit';
import errorHandlerReducer from 'components/ErrorMessageHandler/slice';
import paymentDateReducer from 'components/PaymentDatePicker/slice';
import storeSelectReducer from 'components/StoreSelect/slice';
import successHandlerReducer from 'components/SuccessMessage/slice';
import authorizePaymentReviewReducer from 'pages/AuthorizePaymentPage/slice';
import pageHeaderReducer from 'pages/LandingPage/components/LandingPageHeader/slice';
import userDataReducer from 'pages/LandingPage/slice';
import reconciliationReducer from 'pages/ReconciliationReportPage/slice';
import authorizePaymentReducer from 'pages/VendorPaymentResultPage/slice';
import checkSequencingReducer from 'pages/VendorsTablePage/components/PrintChecks/CheckSequence/slice';
import printChecksReducer from 'pages/VendorsTablePage/components/PrintChecks/slice';
import vendorsReducer from 'pages/VendorsTablePage/components/VendorsTable/slice';

export const reducer = {
  header: pageHeaderReducer,
  userData: userDataReducer,
  userStore: storeSelectReducer,
  authorizeReview: authorizePaymentReviewReducer,
  vendors: vendorsReducer,
  authorizePayment: authorizePaymentReducer,
  errorHandler: errorHandlerReducer,
  successHandler: successHandlerReducer,
  printChecks: printChecksReducer,
  checkSequencing: checkSequencingReducer,
  reconciliation: reconciliationReducer,
  paymentDate: paymentDateReducer
};

export const store = configureStore({
  reducer
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
